import { useEffect, useState } from 'react';
import { useGetCampaignTypesQuery } from '@api/apiCompat';

export const useCampaignTypes = () => {
  const [skipQuery, setSkipQuery] = useState(false);
  const { data, isLoading, error } = useGetCampaignTypesQuery(undefined, {
    skip: skipQuery,
    refetchOnFocus: false,
    refetchOnReconnect: false,
  });

  useEffect(() => {
    // Stop retrying on 404 or 500 errors
    if (error && typeof error === 'object' && 'status' in error) {
      const { status } = error as any;
      if (status === 404 || status === 500) {
        setSkipQuery(true);
      }
    }
  }, [error]);

  // Default campaign types to use as fallback (lead generation focused)
  // E-commerce removed - doesn't produce contact data (name, email, phone)
  const defaultCampaignTypes = [
    { campaign_type_id: 1, type_name: 'Local Search', price: 0.5, status: 'active' },
    { campaign_type_id: 3, type_name: 'Real Estate', price: 0.5, status: 'active' },
    { campaign_type_id: 4, type_name: 'Job Sites', price: 0.5, status: 'active' },
    { campaign_type_id: 5, type_name: 'Social Media', price: 0.5, status: 'active' },
    { campaign_type_id: 6, type_name: 'Legal Services', price: 0.5, status: 'active' },
    { campaign_type_id: 7, type_name: 'SaaS/Software', price: 0.5, status: 'active' },
    { campaign_type_id: 8, type_name: 'Industrial/Manufacturing', price: 0.5, status: 'active' },
  ];

  // Use default types if data is null, undefined, or empty
  const finalData = data && data.length > 0 ? data : defaultCampaignTypes;

  return {
    data: finalData,
    isLoading,
    error: error && typeof error === 'object' && 'status' in error && (error as any).status === 404 ? null : error,
  };
};
